/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonContextCto } from '../../models/person-context-cto';
import { PersonUpdateCto } from '../../models/person-update-cto';

export interface UpdatePerson$Plain$Params {
  personGuid: string;
      body?: PersonUpdateCto
}

export function updatePerson$Plain(http: HttpClient, rootUrl: string, params: UpdatePerson$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonContextCto>> {
  const rb = new RequestBuilder(rootUrl, updatePerson$Plain.PATH, 'patch');
  if (params) {
    rb.path('personGuid', params.personGuid, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PersonContextCto>;
    })
  );
}

updatePerson$Plain.PATH = '/person/{personGuid}';
